module.exports = __webpack_public_path__ + "img/satmed-alertanos.caf3a0a1.jpg";